import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-card-dashboard-guest-shortlist',
  templateUrl: './card-dashboard-guest-shortlist.component.html',
  styleUrls: ['./card-dashboard-guest-shortlist.component.scss']
})
export class CardDashboardGuestShortlistComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
